import { useEffect, useState } from "react";

import { createSurveyScriptUrl } from "@checkout-v2/shared/utils/survey/createSurveyScriptUrl";

export const useSurveyScriptUrl = (identifier?: string, domain?: string): string | undefined => {
  const [scriptUrl, setScriptUrl] = useState<string>();

  useEffect(() => {
    if (!identifier || !domain) {
      setScriptUrl(undefined);
      return;
    }

    const { url, revoke } = createSurveyScriptUrl(identifier, domain);
    setScriptUrl(url);

    return () => {
      revoke();
      setScriptUrl(undefined);
    };
  }, [identifier, domain]);

  return scriptUrl;
};
